import { useRouter } from "next/router"
import React from "react"
import { logout } from "network/network"
import Button from "@common/buttons/button"

const LogoutButton = ({ children }) => {
  const router = useRouter()

  return (
    <div className=" absolute right-0 top-0 mt-6 mr-12 ">
      <Button variant="outline" onClick={() => handleLogoutClick(router)}>
        {children || "Logout"}
      </Button>
    </div>
  )
}
export const handleLogoutClick = async (router) => {
  try {
    const { success, isError } = await logout()
    if (isError) {
      handleLogoutError()
    }
    success && router.push("/")
  } catch (e) {
    handleLogoutError()
  }
}

const handleLogoutError = () => {
  alert("Something went wrong, please refresh & try again.")
}
export default LogoutButton
